import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as moment from 'moment';

import { Airport } from '@sd-portal/shared/airport';
import { AircraftProfile, AircraftTypeRating, AircraftListItem } from '../_models';
import { AircraftActiveType } from '@sd-portal/post-flight/models-util';

@Injectable({ providedIn: 'root' })
export class SharedAircraftService {
  constructor(private readonly http: HttpClient) {}

  //TODO: should this come from profile api (not pre-flight)?
  private readonly baseUrl = '/sdapi/pre-flight/AircraftProfiles';

  getAircraftProfiles(
    aircraftActiveType: AircraftActiveType = AircraftActiveType.Active
  ): Observable<AircraftProfile[]> {
    const url = `${this.baseUrl}/AircraftProfileDtos?aircraftProfileStatus=${aircraftActiveType}`;
    return this.http.get<AircraftProfile[]>(url);
  }

  getAircraftProfilesLite(): Observable<AircraftListItem[]> {
    const url = `${this.baseUrl}/AircraftList`;
    return this.http.get<AircraftListItem[]>(url);
  }

  getAircraftProfile(aircraftId: number): Observable<AircraftProfile> {
    const url = `${this.baseUrl}/${aircraftId}`;
    return this.http.get<AircraftProfile>(url);
  }

  getAircraftLastKnownAirport(
    aircraftId: number | null,
    beforeDate: moment.Moment
  ): Observable<Airport> {
    const url = `${this.baseUrl}/${aircraftId}/LastKnownAirport`;
    const params = {
      beforeDate: beforeDate.format('YYYY-MM-DD')
    };

    return this.http.get<Airport>(url, { params });
  }

  getAircraftTypeRatings() {
    const url = `${this.baseUrl}/GetAircraftTypeRatings`;
    return this.http.get<AircraftTypeRating[]>(url);
  }
}
